// ---------------------------------------------------------------------------
// Prezio Onboard Widget — CoverageNudge
// ---------------------------------------------------------------------------
// Subtle info banner shown when the API returns `_coverage` data, indicating
// the user sees fewer options than exist — either because of sandbox curation
// or their plan (`reason`). The widget never checks environment — the presence
// of `_coverage` is the only signal.
// ---------------------------------------------------------------------------

import { t } from '@/i18n';
import { useWidgetConfig } from '@/context/WidgetConfigContext';
import type { CoverageInfo } from '@/api/types';
import styles from './CoverageNudge.module.css';

interface CoverageNudgeProps {
  coverage: CoverageInfo | null | undefined;
}

export function CoverageNudge({ coverage }: CoverageNudgeProps) {
  const { upgradeUrl } = useWidgetConfig();

  if (!coverage) return null;

  return (
    <div className={styles['wrapper']} role="note">
      <span className={styles['text']}>
        {t(coverage.reason === 'plan' ? 'coverage.nudgePlan' : 'coverage.nudge', {
          shown: String(coverage.shown),
          total: String(coverage.total),
        })}
      </span>
      {upgradeUrl && (
        <a
          href={upgradeUrl}
          className={styles['link']}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('coverage.upgrade')} <span aria-hidden="true">→</span>
        </a>
      )}
    </div>
  );
}
